import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSetting } from "../../context/appSettingContext";
import { useAuth } from "../../context/userContext";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import axiosInstance from "../../config/axiosInstance";

function TransferVoucher() {
    const location = useLocation();

    const navigate = useNavigate();

    const { authUser } = useAuth();

    const { appSettings } = useAppSetting();

    const voucher = location.state;

    const [customerShareExist, setCustomerShareExist] = useState(true);

    const [customerData, setCustomerData] = useState({});

    useEffect(() => {
        if (!voucher) {
            navigate("/vouchers");
            getCustomerData();
        }
    }, []);

    const getCustomerData = async (baseURL) => {
        const payLoad = {
            DIV_DES: "",
            DIV_ID: "1",
            FUNCTION: "GetLoyPoints",
            SEND_KEY: "123456",
            DATA: {
                AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                TYPE_NAME: "CUSTOMER",
                MOBILE_NUM: authUser ? authUser.MOBILE : "",
                CLIENT_ID: appSettings.ClientId,
            },
        };
    
        try {
            // Sending the request with Axios
            const { data } = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            // Set the customer data from the response
            setCustomerData(data);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };
    

    const submitShareForm = async (event) => {
        setCustomerShareExist(true);
    
        event.preventDefault();
    
        const formData = new FormData(event.target);
    
        const payLoad = {
            DATA: {
                voucherEntryNo: voucher.entry_no,
                senderMobile: customerData.MOBILE,
                senderEmail: customerData.Email,
                receiverMobile: formData.get("recipient_mobile"),
                receiverEmail: formData.get("recipient_email"),
            },
        };
    
        try {
            // Sending the request using Axios
            const { data } = await axiosInstance.post(`${appSettings.AppBaseURL}/TransferVoucher`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            if (data.STATUS) {
                setCustomerShareExist(true);
                alert("Successful");
            } else {
                setCustomerShareExist(false);
                alert("Failed to share the voucher");
            }
        } catch (error) {
            setCustomerShareExist(false);
            console.error("Error during voucher transfer:", error);
            alert("An error occurred while sharing the voucher.");
        }
    };
    

    return (
        <AnimatedPage className="overflow-hidden">
            <div className="position-sticky z-2">
                <PageTitle name="TRANSFER VOUCHER" />
            </div>
            <div className="h-100 overflow-y-scroll pb-3 bg-wafaa-grey">
                <form className="px-3 mt-3 position-relative h-90 bg-wafaa-grey" onSubmit={(event) => submitShareForm(event)}>
                    <div className="py-2">
                        <p className="font-size-13 font-weight-800 text-black">Recipient Details</p>
                        <div className="bg-white shadow p-3 rounded-3">
                            <div className="d-flex justify-content-between mb-3">
                                <label className="col-2 text-wafaa-grey font-size-14">Email</label>
                                <input className="col-9 border-0 font-size-14 ps-2 text-dark" required name="recipient_email" type="text" placeholder="Enter Email" />
                            </div>
                            <div className="d-flex justify-content-between">
                                <label className="col-2 text-wafaa-grey font-size-14">Mobile</label>
                                <input className="col-9 border-0 font-size-14 ps-2 text-dark" required name="recipient_mobile" type="tel" placeholder="Enter Mobile" />
                            </div>
                        </div>
                        <div className={"font-size-12 text-end pt-3 text-danger " + (customerShareExist ? "d-none" : "d-block")}>Customer does not exist</div>
                    </div>

                    <button type="submit" className="bg-wafaa-purple bottom-0 btn mb-2 mt-3 position-absolute rounded-3 text-white w-85">
                        Share Voucher
                    </button>
                </form>
            </div>
        </AnimatedPage>
    );
}

export default TransferVoucher;
